export default __webpack_public_path__ + "static/media/slider.d079b47b.mp3";